<template>
  <v-container id="productos_restaurante" tag="section">
    <base-v-component heading="Precios de los productos " />
    <base-material-card
      color="indigo"
      icon="mdi-basket"
      inline
      class="px-5 py-3"
    >
      <v-toolbar flat color="white">
        <v-btn color="secondary" dark class="mb-2 mr-4" @click="goBack()"
          >Volver</v-btn
        >
        <v-btn
          color="success"
          dark
          class="mb-2 mr-4"
          :loading="loadingSave"
          :disabled="productosCambiados.length == 0"
          @click="save()"
          >Guardar Tarifas</v-btn
        >

        <v-select
          class="mt-4"
          :items="categorias"
          v-model="categoria"
          label="Categoria"
        ></v-select>
        <!-- <v-select
          class="mt-4"
          :items="cambiarCatalogosJuntosItems"
          v-model="cambiarCatalogosJuntos"
          label="Cambiar Catalogos Juntos"
          multiple
        ></v-select> -->
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-toolbar flat>
        <v-row dense>
          <v-col cols="12" md="3" lg="2">
            <v-btn small text @click="seleccionarNinguno">
              <v-icon>mdi-checkbox-multiple-blank-outline</v-icon>
            </v-btn>
            <v-btn small text @click="seleccionarTodos">
              <v-icon>mdi-checkbox-multiple-marked-outline</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              dense
              multiple
              v-model="tarifasCambiarTodo"
              label="Tarifas a aplicar el cambio"
              :items="tarifas"
              item-text="nombre"
              item-value="id"
              width="200px"
          /></v-col>
        </v-row>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items-per-page="100"
        :items="productosFiltradoCategoria"
        :loading="loading"
        :search="search"
      >
        <template v-slot:item="{ item }">
          <tr :key="item.id">
            <td>{{ item.nombreMostrar }}</td>
            <template v-for="(tar, i) in item.tarifas">
              <td :key="`activo_${i}`" :class="colores[i % 6] + ' lighten-4'">
                <v-checkbox
                  v-model="tar.activo"
                  dense
                  @change="cambiarAsociadoCheckBox($event, item, tar)"
                />
              </td>
              <td :key="`impuesto_${i}`" :class="colores[i % 6] + ' lighten-4'">
                <v-select
                  v-model="tar.impuesto"
                  :items="impuestos"
                  dense
                  hide-details
                  @change="cambiarAsociado(item)"
                />
              </td>
              <td :key="`precio_${i}`" :class="colores[i % 6] + ' lighten-4'">
                <v-text-field
                  dense
                  type="number"
                  step="0.5"
                  v-model="tar.precio"
                  @change="cambiarAsociado(item)"
                />
              </td>
            </template>
          </tr>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>
        
        <script>
import { mapGetters, mapState } from "vuex";
import { mostrarIdioma } from "@/utils/utils.js";

export default {
  data() {
    return {
      tarifasCambiarTodo: [],
      colores: ["yellow", "red", "blue", "purple", "green", "pink"],

      loading: false,
      loadingSave: false,
      headersBruto: [
        {
          sortable: false,
          text: "Nombre",
          value: "nombreMostrar",
        },
      ],
      productosCambiados: [],
    };
  },
  computed: {
    search: {
      get() {
        return this.$store.state.productos.busqueda;
      },
      set(v) {
        this.$store.commit("productos/setBusqueda", v);
      },
    },
    ...mapState({
      tarifas: (state) => state.productos.tarifas,
      negocioObjGest: (state) => state.app.negocioObjGest,
      impuestoDefecto: (state) => state.impuestos.impuestoProductosDefecto.id,
      //   productosBruto: (state) => state.productos.productosArray,
    }),
    ...mapGetters({
      categorias: "categorias/getCategoriasSelect",
      productosBruto: "productos/productosListadoTodos",
      impuestos: "impuestos/getImpuestosSelect",
      restGestObj: "app/restGestObj",
    }),
    categoria: {
      get() {
        return this.$store.state.productos.categoriaFiltrar;
      },
      set(v) {
        this.$store.commit("productos/setCategoriaFiltrar", v);
      },
    },
    headers() {
      return [
        ...this.headersBruto,
        ...this.tarifas
          .map((h) => {
            return [
              {
                sortable: false,
                text: h.nombre + " Activo",
                value: "activo",
              },
              {
                sortable: false,
                text: h.nombre + " Impuesto",
                value: "impuesto",
              },
              {
                sortable: false,
                text: h.nombre + " Precio",
                value: "precio",
              },
            ];
          })
          .flat(),
      ];
    },
    productosFiltradoCategoria() {
      return this.productos
        .filter(
          (p) =>
            p.categoria == this.categoria ||
            this.categoria == null ||
            (this.categoria == "menus" && !!p.menu)
        )
        .sort((a, b) => (a.orden > b.orden ? 1 : b.orden > a.orden ? -1 : 0));
    },
    productos() {
      return this.productosBruto
        .filter((p) => p.individualPedible || p.menu)
        .map((p) => {
          var tarifasDevolver = [];
          if (p.tarifas) {
            tarifasDevolver = this.tarifas.map((t) => {
              let found = p.tarifas.find((tar) => tar.id == t.id); //ya tenía esta tarifa;
              if (found) {
                return {
                  id: found.id,
                  activo: found.activo,
                  precio: found.precio,
                  impuesto: found.impuesto,
                };
              } else {
                return {
                  id: t.id,
                  activo: false,
                  precio: 0,
                  impuesto: null,
                };
              }
            });
          } else {
            tarifasDevolver = this.tarifas.map((t) => {
              return {
                id: t.id,
                activo: false,
                precio: 0,
                impuesto: null,
              };
            });
          }
          return {
            ...p,
            tarifas: tarifasDevolver,
          };
        });
    },
  },
  methods: {
    seleccionarTodos() {
      const _vm = this;
      this.productosFiltradoCategoria.map((prd) => {
        // console.log(prd);
        prd.tarifas.map((t, i) => {
          if (this.tarifasCambiarTodo.includes(t.id)) {
            t.activo = true;
            _vm.cambiarAsociadoCheckBox(false, prd, t);
          }
        });
      });
    },
    seleccionarNinguno() {
      const _vm = this;
      this.productosFiltradoCategoria.map((prd) => {
        // console.log(prd);
        prd.tarifas.map((t) => {
          if (this.tarifasCambiarTodo.includes(t.id)) {
            t.activo = false;
            _vm.cambiarAsociadoCheckBox(false, prd, t);
          }
        });
      });
    },
    cambiarAsociadoCheckBox(bool, item, tarifa) {
      if (tarifa.activo) {
        tarifa.precio = item.precioGlobal;
        tarifa.impuesto = this.impuestoDefecto;
      } else {
        tarifa.precio = 0;
        tarifa.impuesto = null;
      }
      this.cambiarAsociado(item);
    },
    cambiarAsociado(item) {
      if (this.productosCambiados.indexOf(item.id) === -1)
        this.productosCambiados.push(item.id);
      //   if (this.catalogosCambiados.indexOf(item.catalogo) == -1)
      //     this.catalogosCambiados.push(item.catalogo);
      //   this.sinCambios = false;
    },
    goBack() {
      let str = "/admin/gest/" + this.negocioObjGest.id + "/almacen/productos";
      this.$router.push(str);
    },
    save() {
      this.loadingSave = true;
      this.loading = true;

      this.$store
        .dispatch(
          "productos/addProductoLote",
          this.productos.filter((p) => this.productosCambiados.includes(p.id))
        )
        .then(() => {
          this.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Precios guardados",
          });
          this.productosCambiados = [];
          return Promise.all([
            this.$store.dispatch("productos/getProductos"),
            this.$store.dispatch("productos/getMenus"),
          ]);
        })

        .catch((error) => {
          console.log(error);
          this.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al actualizar los precios: " + error,
          });
        })
        .finally(() => {
          this.loadingSave = false;
          this.loading = false;
        });
    },
  },
};
</script>
        
        <style>
</style>